/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {DatasetRowSelectorChangeOut} from './DatasetRowSelectorChangeOut';
import {
  DatasetRowSelectorChangeOutFromJSON,
  DatasetRowSelectorChangeOutFromJSONTyped,
  DatasetRowSelectorChangeOutToJSON
} from './DatasetRowSelectorChangeOut';

/**
 *
 * @export
 * @interface ResponseStatusDatasetRowSelectorChangeOut
 */
export interface ResponseStatusDatasetRowSelectorChangeOut {
  /**
   *
   * @type {string}
   * @memberof ResponseStatusDatasetRowSelectorChangeOut
   */
  status: string;
  /**
   *
   * @type {DatasetRowSelectorChangeOut}
   * @memberof ResponseStatusDatasetRowSelectorChangeOut
   */
  data?: DatasetRowSelectorChangeOut | null;
  /**
   *
   * @type {string}
   * @memberof ResponseStatusDatasetRowSelectorChangeOut
   */
  errorMsg?: string | null;
}

/**
 * Check if a given object implements the ResponseStatusDatasetRowSelectorChangeOut interface.
 */
export function instanceOfResponseStatusDatasetRowSelectorChangeOut(
  value: object
): value is ResponseStatusDatasetRowSelectorChangeOut {
  if (!('status' in value) || value['status'] === undefined) return false;
  return true;
}

export function ResponseStatusDatasetRowSelectorChangeOutFromJSON(
  json: any
): ResponseStatusDatasetRowSelectorChangeOut {
  return ResponseStatusDatasetRowSelectorChangeOutFromJSONTyped(json, false);
}

export function ResponseStatusDatasetRowSelectorChangeOutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResponseStatusDatasetRowSelectorChangeOut {
  if (json == null) {
    return json;
  }
  return {
    status: json['status'],
    data: json['data'] == null ? undefined : DatasetRowSelectorChangeOutFromJSON(json['data']),
    errorMsg: json['error_msg'] == null ? undefined : json['error_msg']
  };
}

export function ResponseStatusDatasetRowSelectorChangeOutToJSON(
  value?: ResponseStatusDatasetRowSelectorChangeOut | null
): any {
  if (value == null) {
    return value;
  }
  return {
    status: value['status'],
    data: DatasetRowSelectorChangeOutToJSON(value['data']),
    error_msg: value['errorMsg']
  };
}
